/**
 * @file 保存分享到班级
 * @author liudaoyu
 * {@link http://api.umucdn.cn/project/76/interface/api/1019}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ISaveShareOutput {
    result: number;
}

export interface ISaveShareInput {
    class_ids: string; // 班级ID，以“,”分割
    share_type: string; // 5/分享课程, 6/分享小节 7/分享学习项目 8/分享图片
    share_id?: number; // share_type对应的id，图片不需要id
    content: string; // 分享时说的话
    pic_url?: string;
}

export const saveShare = (data: ISaveShareInput): Promise<ISaveShareOutput> => {
    return fetchData(Api.SHARE_ON_CLASS_SAVE_SHARE, data).then((res: IResponse<ISaveShareOutput>) => {
        return res.data as ISaveShareOutput;
    });
};
